import React, { useEffect, useMemo, useState } from 'react';
import { messages } from "../../../../../../messages.js";
import { config } from "../../../../../../config";
import close from "../../../../../../assets/close.svg";
import { maskingToPlainNumber, phoneNumberMask, validateEmail } from '../../../../../../Util/helper';
import axiosApi from '../../../../../../core/interceptor/interceptor';
import _ from 'lodash';
import NumberFormat from 'react-number-format';

const defaultFormValue = {
    first_name: '',
    last_name: '',
    email: '',
    cell_phone: '',
    secondary_phone: '',
    password: '',
    confirm_password: '',
    user_type: 'employee'
}

const userType = 'employee';

export default function AddEditEmployeeModalContent(props) {
    const [emailExist, setEmailExist] = useState(false);
    const [formData, setFormData] = useState(defaultFormValue);
    const [formSubmitted, setFormSubmitted] = useState(false);
    /***** States of form ******/
    useEffect(() => {
        setFormData({
            first_name: '',
            last_name: '',
            email: '',
            cell_phone: '',
            secondary_phone: '',
            password: '',
            confirm_password: '',
            user_type: 'employee'
        });
    }, []);
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        cellPhone: '',
        secondaryPhone: '',
        password: '',
        confirmPassword: '',
    });

    const debouncedCheckEmailExistance = useMemo(
        () => _.debounce(email => checkEmail(email), 1500),
        [],
    );

    useEffect(() => {
        handleValidation();
        //eslint-disable-next-line
    }, [
        formData.first_name,
        formData.last_name,
        formData.email,
        formData.password,
        formData.confirm_password,
        emailExist,
    ]);

    const checkEmail = (email) => {
        axiosApi.post(`${config.apiUrl}/misc/check-email-existance`, { email,user_type:'employee' })
            .then((res) => {
                setEmailExist(!!res.data.data);
            })
            .catch((err) => {
                console.error(err);
            });
    }

    useEffect(() => {
        if (validateEmail(formData.email.trim())) {
            debouncedCheckEmailExistance(formData.email.trim());
        }
        //eslint-disable-next-line
    }, [formData.email]);

    /***** Triggers when form data changes ******/
    const handleFormChange = (event) => {
        setFormData((previousFormData) => ({
            ...previousFormData,
            [event.target.name]: event.target.value,
        }))
    }


    /**** Triggers when form submit *****/
    const handleSubmit = (event) => {
        event.preventDefault();
        setFormSubmitted(true);
        const data = formData;
        data['cell_phone'] = maskingToPlainNumber(data.cell_phone);
        data['secondary_phone'] = maskingToPlainNumber(data.secondary_phone);
        if (handleValidation()) {
            axiosApi.post(`${config.apiUrl}/users/${userType}`, formData)
                .then((res) => {
                    setFormSubmitted(false);
                    if (props.refresh) {
                        props.refresh();
                    }
                    closeModal();

                })
                .catch((error) => {
                    closeModal();
                });
        }
    }

    /*** closes modal *****/
    const closeModal = (resp = false) => {
        if (props.closeModal) {
            props.closeModal(resp);
        }
    }

    const handleValidation = () => {
        let errorArr = {};
        let formIsValid = true;

        /***** name validation ******/
        if (!formData['first_name']) {
            formIsValid = false;
            errorArr["firstName"] = messages.emptyName;
        }

        /***** name validation ******/
        if (!formData['last_name']) {
            formIsValid = false;
            errorArr["lastName"] = messages.emptyLastName;
        }

        /***** email validation ******/
        if (!formData['email'].trim()) {
            formIsValid = false;
            errorArr["email"] = messages.emptyEmail;
        } else if (formData.email) {
            if (!validateEmail((formData.email).trim())) {
                formIsValid = false;
                errorArr["email"] = messages.invalidEmail;
            } else {
                if (emailExist) {
                    formIsValid = false;
                    errorArr["email"] = messages.email_taken;
                }
            }
        }

        /***** password validation ******/
        if (!formData['password']) {
            formIsValid = false;
            errorArr["password"] = messages.emptyPassword;
        } else if (typeof formData['password'] !== "undefined") {
            if (formData['password'].length < 6) {
                formIsValid = false;
                errorArr["password"] = messages.passwordLength;
            }
        }

        /***** confirmPassword validation ******/
        if (!formData['confirm_password']) {
            formIsValid = false;
            errorArr["confirmPassword"] = messages.emptyconfirmPassword;
        } else if (typeof formData['confirm_password'] !== "undefined") {
            if (formData['password'] !== formData['confirm_password']) {
                formIsValid = false;
                errorArr["confirmPassword"] = messages.confirmPasswordError;
            }
        }
        setErrors(errorArr);
        return formIsValid;
    }

    return <>
        <div className="modal">
            <div className="modal-header">
                <h2>Add Employee</h2>
                <p>Enter account info</p>
                <span className="close" onClick={closeModal}>
                    <img src={close} alt='close-icon'/>
                </span>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="add-adminModal">
                    <div className="input-field">
                        <label>First Name<sup>*</sup></label>
                        <input type="text" name="first_name" value={formData.first_name} onChange={handleFormChange} />
                        {formSubmitted && <span className="error">{errors["firstName"]}</span>}
                    </div>
                    <div className="input-field">
                        <label>Last Name<sup>*</sup></label>
                        <input type="text" name="last_name" value={formData.last_name} onChange={handleFormChange} />
                        {formSubmitted && <span className="error">{errors["lastName"]}</span>}
                    </div>
                    <div className="input-field">
                        <label>Email<sup>*</sup></label>
                        <input type="text" name="email" value={formData.email} onKeyUp={handleFormChange} />
                        {(formSubmitted || errors["email"] === messages.email_taken) && <span className="error">{errors["email"]}</span>}
                    </div>
                    <div className="input-field">
                        <label>Primary Phone</label>
                        <NumberFormat format={phoneNumberMask} mask="_"  name="cell_phone" value={formData.cell_phone}   onChange={handleFormChange}/>
                        {formSubmitted && <span className="error">{errors["cellPhone"]}</span>}
                    </div>
                    <div className="input-field">
                        <label>Secondary Phone</label>
                        <NumberFormat format={phoneNumberMask} mask="_"  name="secondary_phone" value={formData.secondary_phone}   onChange={handleFormChange}/>
                        {formSubmitted && <span className="error">{errors["secondaryPhone"]}</span>}
                    </div>
                    <div className="input-field">
                        <label>Password<sup>*</sup></label>
                        <input type="password" name="password" value={formData.password} onChange={handleFormChange} />
                        {formSubmitted && <span className="error">{errors["password"]}</span>}
                    </div>
                    <div className="input-field">
                        <label>Confirm Password<sup>*</sup></label>
                        <input type="password" name="confirm_password" value={formData.confirm_password} onChange={handleFormChange} />
                        {formSubmitted && <span className="error">{errors["confirmPassword"]}</span>}
                    </div>
                </div>
                <div className="modal-footer d-flex">
                    <button className="cancel-btn" onClick={closeModal}>Cancel</button>
                    <button type="submit">Create Employee</button>
                </div>
            </form>
        </div>
    </>
}